// ================================================================================================

function SetupWizard() {
    var allStepNames = Object.keys(wizardSteps);
    for (var i = 0; i < allStepNames.length; i++) {
        var stepConfiguration = wizardSteps[allStepNames[i]];

        if (calendarConfiguration.loginUserType === 'Anonymous' && !stepConfiguration.allowAnonymous) {
            console.info("Skipping step " + allStepNames[i]);
            continue;
        }
        console.info("Compiling step " + allStepNames[i]);

        if (stepConfiguration.onInit) {
            stepConfiguration.onInit();
        }

        if (!stepConfiguration.templateName) {
            console.error("Wizard step " + allStepNames[i] + " is missing required templateName property");
        }

        var $templateDom = $(stepConfiguration.templateName);
        if (!$templateDom.length) {
            console.error("jQuery template object for step type " + allStepNames[i] + " not found");
            continue;
        }
        var templateHtml = $templateDom.html();
        if (!templateHtml) {
            console.error("Template HTML for step type " + allStepNames[i] + " not found");
            continue;
        }
        if (stepConfiguration.skipTemplateCompilation !== true) {
            stepConfiguration.templateCompiled = Handlebars.compile(templateHtml);
        }

        // Validate required functions
        if (!stepConfiguration.getButtonList) {
            console.error("Wizard step " + allStepNames[i] + " is missing required getButtonList function!");
            continue;
        }

        // Place missing functions so we don't need to perform null checks everywhere
        var nothing = function () {
        };

        if (!stepConfiguration.beforeRender) {
            stepConfiguration.beforeRender = nothing;
        }

        if (!stepConfiguration.afterPreparation) {
            stepConfiguration.afterPreparation = nothing;
        }

        if (!stepConfiguration.afterRender) {
            stepConfiguration.afterRender = nothing;
        }

        if (!stepConfiguration.save) {
            stepConfiguration.save = nothing;
        }
    }

    // Compile button template
    buttonTemplate = Handlebars.compile($("#wizardButtonsTemplate").html());
}

// Partially depends on window.currentEvent. This is being set outside (002).
function OpenModal(stepName, optStart, optEnd) {

    var stepConfiguration = wizardSteps[stepName];
    if (!stepConfiguration) {
        console.error("Wizard step " + stepName + " is unknown!");
        return;
    }

    stepStack.push(stepName);

    if (currentStep) {
        currentStep.save();
    }

    var $target = $(".m-modal__form");
    var handlebarsModel = {
        "o": currentEvent,
        "calendarConfiguration": window.calendarConfiguration
    };
    var ctx = {
        $el: $target,
        model: handlebarsModel
    };

    currentStep = stepConfiguration;

    // Setup location before calling beforeRender to ensure it's present.
    if (currentEvent) {
        if (currentResource && currentEvent.constraint && (!currentEvent.constraint.resourceIds || !currentEvent.constraint.resourceIds.length)) {
            // Fill resource Ids array. Order matches AppointmentController:230ff.
            var resourceIds = [];
            if (currentResource.parent) {
                // Add club if present.
                resourceIds.push(currentResource.parent.clubId);
            }
            if (currentResource.internalId) {
                // Add pro if present.
                resourceIds.push(currentResource.internalId);
            }
            // Add club OR location-pro combination depending on current view.
            resourceIds.push(currentResource.id);

            currentEvent.constraint.resourceIds = resourceIds;
        }

        // Setup location id if not present.
        if (!currentEvent.locationId) {
            currentEvent.locationId = (currentResource && currentResource.parent)
                ? currentResource.parent.clubId
                : currentResource
                    ? currentResource.id
                    : currentEvent.constraint && (currentEvent.constraint.resourceIds && currentEvent.constraint.resourceIds.length
                    ? currentEvent.constraint.resourceIds[0] // club should always be first, see AppointmentController:230ff for reference.
                    : null);
        }

        // Setup location if not present.
        if (!currentEvent.location) {
            var location = GetLocationById(currentEvent.locationId);
            if (location && location.title) {
                currentEvent.location = location.title;
            }
        }
    }

    stepConfiguration.beforeRender(ctx);

    if (currentEvent) {
        // By now we always have a currentEvent
        if (!currentEvent.start) {
            currentEvent.start = optStart;
        }

        // By now we always have a currentEvent
        if (!currentEvent.end) {
            currentEvent.end = optEnd;
        }

        if (typeof (currentEvent.trainerId) === 'undefined'
            && calendarConfiguration.loginUserType === 'Golf Academy'
            && currentResource && currentResource.internalId
            && $calendar.fullCalendar("getView").type === "timelineDay") {
            currentEvent.trainerId = currentResource.internalId;
        }
    }

    stepConfiguration.afterPreparation(ctx);

    var renderedHtml = stepConfiguration.skipTemplateCompilation === true
        ? document.querySelector(stepConfiguration.templateName).innerHTML
        : stepConfiguration.templateCompiled(handlebarsModel);
    $target.html(renderedHtml);

    stepConfiguration.afterRender(ctx);

    ctx.stepConfiguration = stepConfiguration;

    _prepareButtons(stepConfiguration, ctx);

    ShowModal();
}

function ShowSaveHintModal(title, text) {
    Modal.show({
        title: title,
        content: '<p>' + text + '</p>',
        actions: [
            {
                title: $t('OK'),
                icon: 'icon-check',
                onClick: function () {
                    currentEvent.cancellationAccepted = true;
                    $btn.click();
                }
            }
        ]
    });
}

function ShowSuccessAnimation(doNotHide) {
    var $modalWrapper = $modal.find('.m-modal__wrapper');
    var $modalContent = $modalWrapper.find('.m-modal__content');

    var modalHeight = $modalWrapper.height();
    var contentOffset = $modalContent.offset();
    var contentWidth = $modalContent.width();
    var $animationContainer = $('.m-success-animation-container');

    $animationContainer.css({
        'top': contentOffset.top,
        'left': contentOffset.left,
        'width': contentWidth,
        'height': modalHeight
    });

    $animationContainer.show();

    if (!doNotHide) {
        setTimeout(function () {
                $animationContainer.hide();
            },
            1500);
    }
}

function ModalSave(conflictResolution, conflictParticipantMessage) {
    // Save the last step
    currentStep.save();

    // Post request to server
    $(".loader").show();

    // Me or anonymous (marketing page or white label) booking things special case
    if ((calendarConfiguration.loginUserType === "Me" || calendarConfiguration.loginUserType === "Anonymous")
        && currentEvent.paymentMethod === "stripe" && currentEvent.price !== 0) {

        console.info("Redirecting without save");
        var url = "/checkout?type=appointment";

        if (currentEvent.id) {
            url += "&id=" + currentEvent.id;
        } else {
            url += "&time="
                + currentEvent.occurences[0].startDate
                + "&location="
                + currentEvent.locationId;

            if (currentEvent.templateId) {
                url += "&product="
                    + currentEvent.templateId
            }

            if (currentEvent.appliance && currentEvent.appliance.id) {
                url += "&appliance=" + currentEvent.appliance.id
                    + "&units=" + currentEvent.appliance.units;

                if (calendarConfiguration.calendarType === "Appliances") {
                    url += "&skipAppointment=true"
                }
            }

            if (currentEvent.description) {
                url += "&description=" + encodeURIComponent(currentEvent.description);
            }
        }

        parent.postMessage({action: "navigate", url: url}, calendarConfiguration.webHostName);
        return;
    }

    var postObj = {};

    if (calendarConfiguration.loginUserType === "Me" && !!currentEvent.id) {
        // Post request to server

        if (currentEvent.price === 0 && currentEvent.paymentMethod !== "flatrate") {
            currentEvent.paymentMethod = null;
        }
        postObj["paymentMethod"] = currentEvent.paymentMethod;

        $.ajax({
            headers: {
                'Access-Control-Allow-Origin': window.calendarConfiguration.apiHostName
            },
            xhrFields: {withCredentials: true},
            url:
                window.calendarConfiguration.apiHostName
                + '/participation/participate/'
                + currentEvent.id
                + '?utcOffset='
                + moment().utcOffset(),
            type: "POST",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(postObj),
            success: function (result) {
                ShowSuccessAnimation();
                $(".loader").hide();

                setTimeout(function () {
                    CloseModal();
                    $calendar.fullCalendar("refetchEvents");

                    if (result.error && result.error.message) {
                        ShowSaveHintModal($t('Termin gespeichert'), result.error.message);
                    }

                    if (window.prepaidUpdateFunction) {
                        window.prepaidUpdateFunction();
                    }

                }, 1500);
            },
            error: function (result) {
                $(".loader").hide();
                console.error(result);
                var showData = 'unknown error';
                if (result.responseJSON.error && result.responseJSON.error.message) {
                    showData = result.responseJSON.error.message;
                } else if (result.responseJSON.data) {
                    showData = result.responseJSON.data;
                }
                ShowErrorPanel(showData);
            }
        });
    } else if (calendarConfiguration.loginUserType !== "Me" || !currentEvent.id) { // TODO What about clubs and academies?

        // Unfortunately we can't just post the whole object to the server.
        // There are circular references as well as internal fullCalendar stuff, so we will reassign the object here
        // In order to not screw up fields in the future, I've opted for a poor man's reflection here.

        var currentEventKeys = Object.keys(currentEvent);

        for (var i = 0; i < currentEventKeys.length; i++) {
            var key = currentEventKeys[i];
            if (key === "_id" || key === "start" || key === "end" || key === "className" || key === "source") {
                continue;
            }
            postObj[key] = currentEvent[key];
        }

        if (conflictResolution) {
            postObj['conflictResolution'] = conflictResolution;
        }
        if (conflictParticipantMessage) {
            postObj['conflictParticipantMessage'] = conflictParticipantMessage;
        }

        postObj["isSchedulerView"] = $calendar.fullCalendar('getView').type === 'timelineDay';

        // Post request to server
        $.ajax({
            headers: {
                'Access-Control-Allow-Origin': window.calendarConfiguration.apiHostName
            },
            xhrFields: {withCredentials: true},
            url: window.calendarConfiguration.apiHostName + '/appointment/' + window.calendarConfiguration.calendarOwnerId,
            type: "POST",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(postObj),
            success: function (result) {
                ShowSuccessAnimation();
                $(".loader").hide();

                setTimeout(function () {
                    CloseModal();
                    $calendar.fullCalendar("refetchEvents");

                    if (result.error && result.error.message) {
                        ShowSaveHintModal($t('Termin gespeichert'), result.error.message);
                    }

                    if (window.prepaidUpdateFunction) {
                        window.prepaidUpdateFunction();
                    }

                }, 1500);
            },
            error: function (result) {
                $(".loader").hide();
                var showData = 'unknown error';
                if (result.responseJSON) {
                    if (calendarConfiguration.loginUserType !== 'Me' && result.status === 409) {
                        window.currentResponse = result.responseJSON;
                        OpenModal('conflict');
                        return;
                    } else if (result.responseJSON.error && result.responseJSON.error.message) {
                        showData = result.responseJSON.error.message;
                    } else if (result.responseJSON.data) {
                        showData = result.responseJSON.data;
                    }
                }
                ShowErrorPanel(showData);
            }
        });
    } else {
        $(".loader").hide();
    }
}

//add price method
$.validator.addMethod("price", function (value, element) {
        var isValidMoney = moneyRegex.test(value);
        return this.optional(element) || isValidMoney;
    },
    $t("Bitte geben sie einen gueltigen Wert ein.")
);

//add date method
$.validator.addMethod("futureOnly", function (value, element) {
        var now = moment();
        var myDate = moment(value, dateTimeFormatString.dateFormat);
        return this.optional(element) || myDate > now;
    },
    $t("Bitte tragen sie ein Datum in der Zukunft ein.")
);

function isPackageValid() {
    var $packageList = $('#m-modal__course-pack-appointment-list');

    if ($packageList.length) {

        if ($packageList.find('.m-modal__course-pack-list-entry').length < 2) {

            return false;
        }
    }

    return true;
}

function _prepareButtons(stepConfiguration, ctx) {
    var buttonsToShow = stepConfiguration.getButtonList(ctx);
    // Back button special case: Hide if there is no step to go back to
    if (stepStack.length < 2) {
        buttonsToShow.back = false;
    }

    var singleTraining = (currentEvent && currentEvent.appointmentType === 'SingleTraining');
    var me = (calendarConfiguration.loginUserType === 'Me' || calendarConfiguration.loginUserType === "Anonymous");

    var $container = $(".m-modal__button-bar--primary");
    $container.html(buttonTemplate(buttonsToShow));
    $container.find("button").click(function () {
        $("#step-validation")
            .submit(function (e) {
                return false;
            });

        var $btn = $(this);
        var action = $btn.data("action");
        if (!action)
            return;

        var validator;

        // Call step specific validation, if present.
        if (currentStep.validate) {
            if (!currentStep.validate(action)) {
                return;
            }
        }

        switch (action) {

            case "goToStep":
                validator = $("#step-validation").validate({
                    rules: {
                        "price": {
                            required: true,
                            price: true
                        },
                        "title": {
                            required: false
                        },
                        "templateId": {
                            required: true
                        }
                    },
                    messages: {
                        "price": {
                            required: $t("Bitte geben sie einen gueltigen Wert ein.")
                        },
                        "title": {
                            required: $t("Der Titel darf nicht leer sein!")
                        },
                        "templateId": {
                            required: $t('Bitte wählen Sie einen Termintypen.')
                        }
                    },
                    submitHandler: function () {
                        validator.destroy();
                        if (!isPackageValid()) {

                            $("div.package-error").show();

                            return false;
                        }
                        OpenModal($btn.data("step-name"));
                        return false;
                    },
                    invalidHandler: function () {
                        if (!isPackageValid()) {

                            $("div.package-error").show();

                            return false;
                        }
                    }
                });
                break;
            case "cancel":
                if (currentStep.cancel()) {
                    if (calendarConfiguration.loginUserType === 'Me' && !currentEvent.cancellationAccepted && currentEvent.cancellingCostsMoney) {
                        Modal.show({
                            title: $t('Termin Stornierung'),
                            content: '<p>' + $t('Achtung, wenn Sie diesen Termin absagen, fallen Stornogebühren an.') + $t('Die Gebühren belaufen sich auf {0}').format(currentEvent.cancellationCosts) + '</p><p>' + $t('Durch Klick auf Ok bestätigen Sie diese Belehrung gelesen zu haben und - sofern sie über MAMP bezahlt haben - werden Ihnen die Gebühren angerechnet.') + '</p>',
                            actions: [
                                {
                                    title: $t('Abbrechen'),
                                    icon: 'icon-cancel',
                                    onClick: function () {
                                        CloseModal();
                                    }
                                }, {
                                    title: $t('OK'),
                                    icon: 'icon-check',
                                    onClick: function () {
                                        currentEvent.cancellationAccepted = true;
                                        $btn.click();
                                    }
                                }]
                        });
                        break;
                    }

                    if (!currentEvent.cancellationAccepted) {
                        Modal.show({
                            title: $t('Vorsicht'),
                            icon: 'icon-attention',
                            content: '<p>' + $t('Möchten Sie diese Aktion durchführen') + '</p>',
                            actions: [
                                {
                                    title: $t('Abbrechen'),
                                    icon: 'icon-cancel',
                                    onClick: function () {
                                        CloseModal();
                                    }
                                },
                                {
                                    title: $t('OK'),
                                    icon: 'icon-check',
                                    onClick: function () {
                                        currentEvent.cancellationAccepted = true;
                                        $btn.click();
                                    }
                                }]
                        });
                        break;
                    }

                    $(".loader").show();
                    if (calendarConfiguration.loginUserType === 'Me') {
                        $.ajax({
                            headers: {
                                'Access-Control-Allow-Origin': window.calendarConfiguration.apiHostName
                            },
                            xhrFields: {withCredentials: true},
                            url:
                                window.calendarConfiguration.apiHostName
                                + '/participation/participate/'
                                + currentEvent.participants[0].participantId
                                + '?utcOffset='
                                + moment().utcOffset(),
                            type: "DELETE",
                            contentType: "application/json; charset=utf-8",
                            success: function (result) {
                                ShowSuccessAnimation();
                                $(".loader").hide();

                                setTimeout(function () {
                                    CloseModal();
                                    $calendar.fullCalendar("refetchEvents");

                                    if (result.error && result.error.message) {
                                        ShowSaveHintModal($t('Termin gespeichert'), result.error.message);
                                    }

                                    if (window.prepaidUpdateFunction) {
                                        window.prepaidUpdateFunction();
                                    }

                                }, 1500);
                            },
                            error: function (result) {
                                $(".loader").hide();
                                console.error(result);
                                var showData = 'unknown error';
                                if (result.responseJSON) {
                                    if (result.responseJSON.error && result.responseJSON.error.message) {
                                        showData = result.responseJSON.error.message;
                                    } else if (result.responseJSON.data) {
                                        showData = result.responseJSON.data;
                                    }
                                }
                                ShowErrorPanel(showData);
                            }
                        });
                    } else {
                        var url = window.calendarConfiguration.apiHostName + '/appointment/';
                        if (calendarConfiguration.loginUserType === 'Golf Academy' && !currentEvent.trainerId) {
                            url += "";
                        } else if (currentEvent.trainerId) {
                            url += currentEvent.trainerId + '/';
                        } else {
                            url += calendarConfiguration.calendarOwnerId + '/';
                        }
                        url += currentEvent.appointmentId + '/occurence/' + currentEvent.id;

                        $.ajax({
                            headers: {
                                'Access-Control-Allow-Origin': window.calendarConfiguration.apiHostName
                            },
                            xhrFields: {withCredentials: true},
                            url: url,
                            type: "DELETE",
                            contentType: "application/json; charset=utf-8",
                            success: function (result) {
                                ShowSuccessAnimation();
                                $(".loader").hide();

                                setTimeout(function () {
                                    CloseModal();
                                    $calendar.fullCalendar("refetchEvents");

                                    if (result.error && result.error.message) {
                                        ShowSaveHintModal($t('Termin gespeichert'), result.error.message);
                                    }

                                    if (window.prepaidUpdateFunction) {
                                        window.prepaidUpdateFunction();
                                    }

                                }, 1500);
                            },
                            error: function (result) {
                                $(".loader").hide();
                                console.error(result);
                                var showData = 'unknown error';
                                if (result.responseJSON) {
                                    if (result.responseJSON.error && result.responseJSON.error.message) {
                                        showData = result.responseJSON.error.message;
                                    } else if (result.responseJSON.data) {
                                        showData = result.responseJSON.data;
                                    }
                                }
                                ShowErrorPanel(showData);
                            }
                        });
                    }
                }
                break;
            case "advertise":
                OpenModal("advertise");
                break;
            case "series":
                OpenModal("series");
                break;
            case "save":
                validator = $('#step-validation').validate({
                    rules: {
                        "participants-count": {
                            required: (singleTraining && !me)
                        },
                        "price": {
                            required: !me,
                            price: true
                        },
                        "title": {
                            required: false
                        },
                        "templateId": {
                            required: true
                        }
                    },
                    messages: {
                        "price": {
                            required: $t("Bitte geben sie einen gueltigen Wert ein.")
                        },
                        "title": {
                            required: $t("Der Titel darf nicht leer sein!")
                        },
                        "templateId": {
                            required: $t('Bitte wählen Sie einen Termintypen.')
                        }
                    },
                    submitHandler: function () {
                        validator.destroy();
                        var participantsCountSingle = ($('.m-modal__participants-display').find('.m-modal__participant-name').length === currentEvent.maxParticipants);
                        var participantsCountMax = $('.m-modal__participants-display').find('.m-modal__participant-name').length > currentEvent.maxParticipants;
                        var inputParticipant = $('#m-modal__input-participants-count');

                        var $participantsBox = $('.m-modal__participant-box');

                        if (participantsCountSingle && singleTraining || !participantsCountMax && !singleTraining || me) {

                            if (!singleTraining) {

                                inputParticipant.removeClass('error');

                                // check only for singleTraining
                            } else if ($participantsBox.length) {

                                $participantsBox.removeClass('m-modal__error-border');
                            }

                            ModalSave();
                        } else {
                            $participantsBox.addClass('m-modal__error-border');
                        }

                        return false;
                    }
                });
                break;
            case "cancelAppointment":
                if (!currentEvent.cancellationAccepted) {
                    Modal.show({
                        title: $t('Vorsicht'),
                        icon: 'icon-attention',
                        content: '<p>' + $t('Möchten Sie diese Aktion durchführen') + '</p>',
                        actions: [
                            {
                                title: $t('Abbrechen'),
                                icon: 'icon-cancel',
                                onClick: function () {
                                    CloseModal();
                                }
                            },
                            {
                                title: $t('OK'),
                                icon: 'icon-check',
                                onClick: function () {
                                    currentEvent.cancellationAccepted = true;
                                    $btn.click();
                                }
                            }]
                    });
                    break;
                }

                $(".loader").show();
                ApiClient.cancelAppointment(currentEvent.appointmentId).done(function (result) {
                    ShowSuccessAnimation();
                    $(".loader").hide();

                    setTimeout(function () {
                        CloseModal();
                        $calendar.fullCalendar("refetchEvents");

                        if (result.error && result.error.message) {
                            ShowSaveHintModal($t('Termin gespeichert'), result.error.message);
                        }

                        if (window.prepaidUpdateFunction) {
                            window.prepaidUpdateFunction();
                        }

                    }, 1500);
                }).fail(function (result) {
                    $(".loader").hide();
                    var showData = 'unknown error';
                    if (result.responseJSON) {
                        if (result.responseJSON.error && result.responseJSON.error.message) {
                            showData = result.responseJSON.error.message;
                        } else if (result.responseJSON.data) {
                            showData = result.responseJSON.data;
                        }
                    }
                    ShowErrorPanel(showData);
                });
                break;
            case "back":
                stepStack.pop(); // Current step
                var prevStep = stepStack.pop(); // The step before
                if (prevStep) {
                    OpenModal(prevStep);
                }
                break;
            case "updateseries":
                validator = $('#step-validation').validate({
                    rules: {
                        "interval": {
                            required: $("input[name='isSeries']").is(':checked'),
                            min: 1
                        },
                        "endDate": {
                            required: $("input[name='isSeries']").is(':checked'),
                            futureOnly: true
                        },
                        "amount": {
                            required: $("input[name='isSeries']").is(':checked'),
                            min: 2
                        }
                    },
                    messages: {
                        "interval": {
                            required: $t('Dieses Feld muss befüllt sein.'),
                            min: $t("Die Anzahl der Wiederholungen ist falsch.")
                        },
                        "endDate": {
                            required: $t("Bitte tragen sie ein Datum in der Zukunft ein")
                        },
                        "amount": {
                            required: $t('Dieses Feld muss befüllt sein.'),
                            min: $t("Die Anzahl muss größer als 1 sein.")
                        }
                    },
                    submitHandler: function () {
                        validator.destroy();
                        stepStack.pop(); // Current step
                        var prevStep = stepStack.pop(); // The step before
                        if (prevStep) {
                            OpenModal(prevStep);
                        }
                        return false;
                    }
                });
                break;
            case "sendComment":
                validator = $('#step-validation').validate({
                    rules: {
                        "comments": {
                            required: true
                        }
                    },
                    messages: {
                        "comments": {
                            required: $t("Bitte füllen Sie dieses Feld aus.")
                        }
                    },
                    submitHandler: function () {
                        validator.destroy();
                        currentStep.saveComments(ctx);
                        return false;
                    }
                });
                break;
            case "whiteLabelLogin":
                parent.postMessage({action: "navigate", url: "login"}, calendarConfiguration.webHostName);
                break;
            case "whiteLabelRegister":
                parent.postMessage({action: "navigate", url: "register"}, calendarConfiguration.webHostName);
                break;
        }
    });
}

function CloseModal() {
    parent.postMessage({open: false}, calendarConfiguration.webHostName);
    $modal.hide();
    $(".m-modal__notification--error").hide();
    stepStack = [];
    currentEvent = null;
    currentStep = null;
    window.performResize();
}

function ShowModal() {
    parent.postMessage({open: true}, calendarConfiguration.webHostName);
    $modal.show();
    window.performResize();
    PositionModal();

    //control the visibility of appointment discussion button
    if (currentEvent && currentEvent.appointmentType === "Absence") {
        $modal.find('#m-modal__btn-discussion').hide();
        return;
    }
    if (!currentEvent || !currentEvent.id || ["discussion", "chooseTextTemplate"].compareArray(stepStack).length) {
        $modal.find('#m-modal__btn-discussion').hide();
    } else {
        $modal.find('#m-modal__btn-discussion').show();
    }
}

// ================================================================================================

function PositionModal($modalWrapper) {
    if (!$modalWrapper) $modalWrapper = $modal.find('.m-modal__wrapper');

    var newOffsetTop = window.parentScrollOffset;

    var windowHeight = $(window).height();
    var modalHeight = $modalWrapper.height();
    var maxPos = windowHeight - 50;
    var modalOffsetBottom = modalHeight + newOffsetTop;
    if (modalOffsetBottom >= maxPos) {
        var diff = modalOffsetBottom - maxPos;
        newOffsetTop = (window.parentScrollOffset - diff > 50) ? window.parentScrollOffset - diff : 0;
    }

    $modalWrapper.attr('style', 'transform: translateY(' + newOffsetTop + 'px);');

    RepaintModal(true);
}

function RepaintModal(callAgain) {
    if (navigator.userAgent.indexOf('Trident') >= 0) {
        setTimeout(function () {
            $('.m-modal__wrapper').addClass('m-modal__ie-rendering-fix');

            // IE, please fuck you big time.
            // We need a timeout here, because IE does not re-render the modal if the class is added and then immediately removed.
            setTimeout(function () {
                $('.m-modal__wrapper').removeClass('m-modal__ie-rendering-fix');
                if (callAgain) {
                    RepaintModal();
                }
            }, 0); // Try to reduce flickering as much as possible.
        }, 250); // Sadly this is the minimal required timeout for this fix to work. Lower values seem to do nothing.
    }
}

function CloseModalTree() {
    if ($('#g-modal').is(':visible')) {
        Modal.hide();
    } else {
        CloseModal();
    }
}

$(document)
    .keyup(function (e) {
        // Check for ESCAPE
        if (e.keyCode === 27) {
            CloseModalTree();
        }
    });

window.addEventListener('message',
    function (e) {
        // Check for ESCAPE
        if (e && e.data && e.data.action && e.data.action === 'keyPress' && e.data.keyCode === 27) {
            CloseModalTree();
        }
    });
